import { Col, Row, Select, Table, Alert } from "antd";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
const { Option } = Select;

const backendFields = [
  "firstname",
  "lastname",
  "emailId",
  "mobile",
  "companyName",
  "phoneNo",
  "oppurtunityAmount",
  "title",
  "website",
  "address",
  "industryText",
  "rate",
  "status",
  "description",
  "leadRating",
];

const properHeaderMapping = {
  firstname: "First Name",
  lastname: "Last Name",
  emailId: "Email",
  companyName: "Company Name",
  mobile: "Mobile Number",
  phoneNo: "Phone Number",
  oppurtunityAmount: "Opportunity Amount",
  title: "Designation",
  website: "Website",
  address: "Address",
  industryText: "Industry",
  rate: "Potential Revenue",
  status: "Status",
  description: "Description",
  leadRating: "Lead Rating",
};

const mandatoryFields = ["firstname", "lastname", "emailId", "mobile"];

const Mapping = ({ csvImportPayload, setCsvImportPayload, setError }) => {
  const [validationError, setValidationError] = useState(false);

  const mergedMappingItems = useMemo(() => {
    const current = csvImportPayload?.mappingItems || [];
    return backendFields.map((field) => {
      const found = current.find((item) => item.field === field);
      if (found) return found;

      const autoHeader = csvImportPayload?.fileHeaders?.includes(
        properHeaderMapping[field],
      )
        ? properHeaderMapping[field]
        : null;

      return { field, mappingField: autoHeader };
    });
  }, [csvImportPayload]);

  const handleMappingChange = (backendField, newHeader) => {
    const updated = mergedMappingItems.map((item) =>
      item.field === backendField ? { ...item, mappingField: newHeader } : item,
    );
    setCsvImportPayload({ ...csvImportPayload, mappingItems: updated });
  };

  useEffect(() => {
    const missingMandatory = mergedMappingItems.some(
      (item) => mandatoryFields.includes(item.field) && !item.mappingField,
    );
    setValidationError(missingMandatory);
    if (setError) {
      if (missingMandatory) {
        setError(
          "Please map all mandatory fields: First Name, Last Name, Email, Phone Number, Company Name",
        );
      } else {
        setError(undefined);
      }
    }
  }, [mergedMappingItems, setError]);

  useEffect(() => {
    if (!csvImportPayload?.mappingItems && mergedMappingItems.length > 0) {
      setCsvImportPayload((prev) => ({
        ...prev,
        mappingItems: mergedMappingItems,
      }));
    }
  }, [mergedMappingItems, csvImportPayload?.mappingItems, setCsvImportPayload]);

  const usedHeaders = mergedMappingItems
    .map((i) => i.mappingField)
    .filter(Boolean);

  const columns = [
    {
      title: "Matched",
      dataIndex: "mappingField",
      key: "matched",
      render: (mappingField) =>
        mappingField ? (
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        ) : (
          <CloseCircleTwoTone twoToneColor="#ff4d4f" />
        ),
      width: 100,
    },
    { title: "Backend Field", dataIndex: "field", key: "field" },
    {
      title: "Matched Header",
      dataIndex: "mappingField",
      key: "header",
      render: (val) =>
        val ? val : <span style={{ color: "#aaa" }}>Not mapped</span>,
    },
    {
      title: "Map To Header",
      dataIndex: "field",
      key: "mappingFieldSelect",
      render: (backendField) => (
        <Select
          value={
            mergedMappingItems.find((i) => i.field === backendField)
              ?.mappingField
          }
          style={{ width: 200 }}
          placeholder="Select header"
          allowClear
          onChange={(val) => handleMappingChange(backendField, val)}
        >
          {csvImportPayload?.fileHeaders?.map((header) => (
            <Option
              key={header}
              value={header}
              disabled={
                usedHeaders.includes(header) &&
                mergedMappingItems.find((i) => i.field === backendField)
                  ?.mappingField !== header
              }
            >
              {header}
            </Option>
          ))}
        </Select>
      ),
    },
  ];

  return (
    <Row className="p-6">
      <Col span={24}>
        {validationError && (
          <Alert
            message="Please map all mandatory fields: First Name, Last Name, Email, Phone Number, Company Name"
            type="error"
            showIcon
            className="tw-my-5"
          />
        )}
        <Table
          dataSource={mergedMappingItems}
          columns={columns}
          pagination={false}
          rowKey="field"
          className="mapping-table"
        />
      </Col>
    </Row>
  );
};

export default Mapping;
